import React from "react";
import { motion } from "framer-motion";

const Box = ({
	boximage,
	textcolor,
	boxicon,
	boxname,
	boxdata,
	boxdatashow,
	bgimage,
	bgcolor,
	classprops,
	boxclass,
	blurfilter,
	elments,
}) => {
	console.log(elments);
	return (
		<div className="box-container">
			<div
				className={boxclass}
				style={{
					backgroundImage: `url(${bgimage})`,
					backgroundColor: bgcolor,
					backgroundSize: "cover",
					color: textcolor,
					borderColor: "black",
					filter: "blur(0.5)",
				}}
			>
				<div className={classprops} style={blurfilter}>
					<div className="box-content">
						{boxname && (
							<div>
								<div className="svg">{boximage}</div>

								<div>
									<span className="smallboxicon">
										{boxicon} {boxname}
									</span>
								</div>

								<div>
									<span className="boxdata">
										{boxdata}
										{boxdatashow}
									</span>
								</div>
							</div>
						)}
						{elments}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Box;
